module.exports = __webpack_public_path__ + "static/grid-example-750fcca96d6fec7a77435d6139f50c3e.png";